/* zweiherzig — Farbkacheln in der Variantenauswahl
   Dawn zeigt Farben als Textknöpfe. Hier bekommt jeder Knopf ein Farbquadrat davor.
   Die Zuordnung deckt alle Farbnamen ab, die im Sortiment tatsächlich vorkommen.
   Neue Farbe? Hier eintragen, sonst bleibt der Knopf ohne Quadrat (kein Fehler). */
(function () {
  "use strict";

  var FARBEN = {
    "natur":     "#ded3bd",
    "beige":     "#d7c9ad",
    "wei\u00df":      "#f7f5f0",
    "weiss":     "#f7f5f0",
    "senfgelb":  "#c69a3e",
    "gelb":      "#dfb64a",
    "rot":       "#b23a34",
    "rosa":      "#d98ca6",
    "lila":      "#7d6f96",
    "blau":      "#4a6b8a",
    "braun":     "#7a5a44",
    "anthrazit": "#3f3d3c",
    "schwarz":   "#1b1a19"
  };

  function istFarbGruppe(el) {
    var lab = el.querySelector(".form__label, legend");
    if (!lab) return false;
    return /farbe/i.test(lab.textContent || "");
  }

  function malen() {
    var gruppen = document.querySelectorAll(".product-form__input");
    for (var i = 0; i < gruppen.length; i++) {
      var g = gruppen[i];
      if (!istFarbGruppe(g)) continue;
      g.classList.add("zwh-farbgruppe");
      var labels = g.querySelectorAll("label");
      for (var j = 0; j < labels.length; j++) {
        var l = labels[j];
        if (l.querySelector(".zwh-dot")) continue;
        var name = (l.textContent || "").trim().toLowerCase();
        var hex = FARBEN[name];
        if (!hex) continue;
        var dot = document.createElement("span");
        dot.className = "zwh-dot";
        dot.style.background = hex;
        dot.setAttribute("aria-hidden", "true");
        l.insertBefore(dot, l.firstChild);
      }
    }
  }

  function start() {
    malen();
    // Dawn rendert die Auswahl beim Variantenwechsel neu
    var ziel = document.querySelector(".product__info-container") || document.body;
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (t.classList && t.classList.contains("zwh-dot")) return;
      }
      malen();
    }).observe(ziel, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();
